import type { CompanyFilters } from "../../types";
import type { ItSpendSlice } from "../itSpend/slice";
import {
  fromCompanyFilters as fromSpendFilters,
  toCompanyFilters as toSpendFilters,
} from "../itSpend/mapper";

export function toCompanyFilters(slice: ItSpendSlice): Partial<CompanyFilters> {
  const { spend } = toSpendFilters(slice);
  return spend ? { aiSpend: spend } : {};
}

export function fromCompanyFilters(filters: CompanyFilters): ItSpendSlice {
  return fromSpendFilters({ spend: filters.aiSpend });
}
